// Angular
import { ErrorHandler, Injectable, OnDestroy, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

// Libraries
import { throwError } from 'rxjs';

// Models
import { AppCleanup } from '../models';

// Services
import { LoggingService } from './logging.service';

// Environment
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class ErrorHandlerService extends AppCleanup implements OnInit, OnDestroy {
	constructor(private loggingService: LoggingService) {
		super();
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	handleError(error: Error) {
		console.log('Error occured:', error);
		if (environment.appInsights.instrumentationKey) {
			// Checking if key exists
			this.loggingService.logException(error); // Manually log exception
		}
	}

	throwServerError() {
		const errorResponse = new HttpErrorResponse({
			error: { code: `some code`, message: `some message.` },
			status: 400,
			statusText: 'Bad Request',
		});

		return throwError(errorResponse) as any;
	}

	throwClientError() {
		let object = null;
		return object.NonExistent;
	}
}
